(function () {
  const storageKey = 'efp_selected_cause_v1';
  const visitKey = 'efp_visit_cause_v1';
  const causes = Array.isArray(window.EFP_CAUSES) ? window.EFP_CAUSES : [];
  const fallback = causes.find((cause) => cause.status === 'available') || causes[0];
  if (!fallback) return;

  const root = document.documentElement;
  const randomCause = () => {
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      const value = new Uint32Array(1);
      window.crypto.getRandomValues(value);
      return causes[value[0] % causes.length];
    }
    return causes[Math.floor(Math.random() * causes.length)];
  };

  const readSelected = () => {
    try {
      const visitCause = window.sessionStorage.getItem(visitKey);
      const visited = causes.find((cause) => cause.id === visitCause);
      if (visited) return visited;
      if (root.classList.contains('efp-interface-home')) {
        const seeded = randomCause();
        window.sessionStorage.setItem(visitKey, seeded.id);
        window.localStorage.setItem(storageKey, seeded.id);
        return seeded;
      }
      const stored = window.localStorage.getItem(storageKey);
      return causes.find((cause) => cause.id === stored) || fallback;
    } catch (_error) {
      return fallback;
    }
  };

  let selected = readSelected();

  function labelStatus(cause) {
    return cause.status === 'available' ? 'AVAILABLE NOW' : 'COLOR IN DEVELOPMENT';
  }

  function writeSelected(cause) {
    selected = cause;
    try {
      window.localStorage.setItem(storageKey, cause.id);
      window.sessionStorage.setItem(visitKey, cause.id);
    } catch (_error) {}
    root.classList.add('efp-cause-switching');
    root.style.setProperty('--cause', cause.color);
    root.dataset.efpCause = cause.id;
    const atlas = window.EFP_ATLAS && window.EFP_ATLAS[cause.id];
    document.querySelectorAll('[data-cause-name]').forEach((node) => { node.textContent = cause.name; });
    document.querySelectorAll('[data-cause-color-name]').forEach((node) => { node.textContent = cause.colorName; });
    document.querySelectorAll('[data-cause-status]').forEach((node) => { node.textContent = labelStatus(cause); });
    document.querySelectorAll('[data-cause-line]').forEach((node) => { node.textContent = atlas ? atlas[0] : cause.name; });
    document.querySelectorAll('[data-cause-mission]').forEach((node) => { node.textContent = atlas ? atlas[1] : ''; });
    document.querySelectorAll('[data-cause-select]').forEach((node) => { node.value = cause.id; });
    document.querySelectorAll('[data-cause-request-section]').forEach((node) => { node.hidden = cause.status === 'available'; });
    document.querySelectorAll('[data-cause-request-link]').forEach((node) => {
      node.hidden = cause.status === 'available';
      node.href = `/pages/contact?cause=${encodeURIComponent(cause.name)}`;
    });
    document.querySelectorAll('[data-cause-request-body]').forEach((node) => {
      node.value = `Future cause request\nCause: ${cause.name}\nColor concept: ${cause.colorName}\nStatus: ${labelStatus(cause)}`;
    });
    document.querySelectorAll('[data-cause-available-only]').forEach((node) => {
      if (node.hasAttribute('data-cause-guided')) {
        node.disabled = false;
        node.setAttribute('aria-disabled', 'false');
        node.textContent = cause.status === 'available'
          ? 'CONTINUE TO SECURE CHECKOUT — $20 →'
          : 'CHOOSE AN AVAILABLE CAUSE TO CHECK OUT →';
        return;
      }
      node.toggleAttribute('disabled', cause.status !== 'available');
      node.setAttribute('aria-disabled', cause.status === 'available' ? 'false' : 'true');
    });
    window.setTimeout(() => root.classList.remove('efp-cause-switching'), 180);
    document.dispatchEvent(new CustomEvent('efp:cause-change', { detail: cause }));
  }

  function renderOptions(select) {
    select.innerHTML = causes.map((cause) => `<option value="${cause.id}">${cause.name}</option>`).join('');
    select.value = selected.id;
    select.addEventListener('change', () => writeSelected(causes.find((cause) => cause.id === select.value) || fallback));
  }

  function renderList(query) {
    const list = document.querySelector('[data-cause-list]');
    if (!list) return;
    const normalized = query.trim().toLowerCase();
    const matching = causes.filter((cause) => !normalized || `${cause.name} ${cause.group}`.toLowerCase().includes(normalized));
    list.innerHTML = matching.map((cause) => `
      <button class="efp-cause-option ${cause.id === selected.id ? 'is-selected' : ''}" type="button" data-cause-option="${cause.id}" aria-pressed="${cause.id === selected.id}">
        <i style="--option-color:${cause.color}" aria-hidden="true"></i>
        <span><b>${cause.name}</b><small>${cause.group}</small></span>
        <em>${cause.colorName}</em>
      </button>`).join('') || '<p class="efp-cause-empty">No causes match that search. Try another word, or choose the closest cause to start the conversation.</p>';
    list.querySelectorAll('[data-cause-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const cause = causes.find((item) => item.id === button.dataset.causeOption);
        if (cause) writeSelected(cause);
        closePicker();
      });
    });
  }

  function openPicker() {
    const picker = document.querySelector('[data-cause-picker]');
    if (!picker) return;
    picker.hidden = false;
    document.body.classList.add('efp-picker-open');
    const input = picker.querySelector('[data-cause-search]');
    renderList(input ? input.value : '');
    window.setTimeout(() => input?.focus(), 20);
  }

  function closePicker() {
    const picker = document.querySelector('[data-cause-picker]');
    if (!picker) return;
    picker.hidden = true;
    document.body.classList.remove('efp-picker-open');
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-cause-select]').forEach(renderOptions);
    document.querySelectorAll('[data-open-cause-picker]').forEach((button) => button.addEventListener('click', openPicker));
    document.querySelectorAll('[data-close-cause-picker]').forEach((button) => button.addEventListener('click', closePicker));
    const search = document.querySelector('[data-cause-search]');
    search?.addEventListener('input', () => renderList(search.value));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePicker(); });
    document.querySelector('[data-cause-picker]')?.addEventListener('click', (event) => {
      if (event.target.matches('[data-cause-picker]')) closePicker();
    });
    writeSelected(selected);
  });

  window.EFP = { causes, getCause: () => selected, selectCause: writeSelected };
})();
